import { Component, computed, input, output } from '@angular/core'
import { DatePipe } from '@angular/common'

import { Icon, IconName } from '@shared/ui'
import { Notification, NotificationKind } from '../../models/notification.model'

/** Icono y color por tipo de aviso, con los tokens del kit. */
const KIND: Record<NotificationKind, { icon: IconName; color: string }> = {
  ticket: { icon: 'circle-check', color: 'text-status-green' },
  prize: { icon: 'circle-plus', color: 'text-gold-peach' },
  challenge: { icon: 'chevron-up', color: 'text-blue-frost' },
  news: { icon: 'file-text', color: 'text-blue-sky' },
  alert: { icon: 'triangle-alert', color: 'text-action-red' }
}

/** Solo presenta el aviso; qué pasa al tocarlo lo decide el panel. */
@Component({
  selector: 'notification-item',
  imports: [Icon, DatePipe],
  host: { class: 'block' },
  templateUrl: './notification-item.html'
})
export class NotificationItem {
  readonly notification = input.required<Notification>()
  readonly selected = output<Notification>()

  protected readonly kind = computed(() => KIND[this.notification().kind])
}
